var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"v-icon mdi-icon theme--light",style:({ transform: ("rotate(" + _vm.rotate + "deg)") }),attrs:{"viewBox":_vm.viewBox,"fill":_vm.fill,"height":_vm.size,"width":_vm.size}},[_c('path',{attrs:{"d":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }